import { useTranslation } from 'react-i18next';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Container, Paper } from '@mui/material';
import { WStateLayout } from '@wareclouds/wareclouds-ui';

export default function NoPendingOrders() {
  const { t } = useTranslation(['description', 'title']);

  return (
    <Paper sx={{ p: 2 }}>
      <Container maxWidth="xl">
        <WStateLayout
          title={t('orders.crossdocking.no_pending_orders', {
            ns: 'title',
          })}
          description={t('orders.crossdocking.no_pending_orders', {
            ns: 'description',
          })}
        >
          <CheckCircleIcon
            sx={{ fontSize: '100px', color: 'secondary.main' }}
          />
        </WStateLayout>
      </Container>
    </Paper>
  );
}
